/**
 * TableDTE = componente para mostrar los items en la tabla.
 * Documentos donde se utiliza: Facturación CF, Factura Sujeto Excluido
 */

import React, {useEffect, useState} from 'react'
import EditIcon from '../../../media/felsv/PenEdit.svg'
import DeleteIcon from '../../../media/felsv/MinusDelete.svg'
import { Pagination } from '../../Pagination'
import { useSelector } from 'react-redux'
import { State } from '../../../reducers'

const TableDTE = (props: any) => {
  const [tableProductos, setTableProductos] = useState(props?.rows || [])
  const {unidadesMedida} = useSelector((state: State) => state.catalogos)

  useEffect(() => {
    setTableProductos(props?.rows)
  }, [props?.rows])

  return (
    <div style={{overflowX: "auto", width: "100%"}}>
      <table className='table-main-responsive responsive-table-main td-left table-pointer'>
        <thead>
          <tr>
            <td>Cantidad</td>
            <td>Unidad de medida</td>
            <td>Tipo</td>
            <td>Descripción</td>
            <td>{props?.idDoc === '01' ? 'Precio con IVA' : 'Precio'}</td>
            <td>Descuento por item</td>
            <td>Ventas gravadas</td>
            <td>Ventas exentas</td>
            <td>Ventas no sujetas</td>
            {props?.sinAcciones !== true && <td>Acciones</td>}
          </tr>
        </thead>
        <tbody>
          {tableProductos.map((producto:any, index:number) => (
            <tr key={index}>
              <td data-label="Cantidad">{producto.cantidadNew}</td>
              <td data-label="Unidad de medida">{unidadesMedida?.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor}</td>
              <td data-label="Tipo">{producto.tipoNew}</td>
              <td data-label="Descripción" style={{wordBreak:"break-all"}}>{producto.descripcion}</td>
              <td data-label={props?.idDoc === '01' ? 'Precio con IVA' : 'Precio'}>{producto.precioNew}</td>
              <td data-label="Descuento por item">{producto.cantidadDescuentoNew}</td>
              <td data-label="Ventas gravadas">{producto.ventasGravadas}</td>
              <td data-label="Ventas exentas">{producto.ventasExentas}</td>
              <td data-label="Ventas no sujetas">{producto.ventasSujetas}</td>
              {props?.sinAcciones !== true && 
                <td data-label="Acciones">
                    <button onClick={() => props.openModalEditar(index, producto)}><img alt='Edit' src={EditIcon} /></button>
                    <button onClick={() => props.openModalEliminar(index)}><img alt='Delete' src={DeleteIcon} /></button>
                </td>}
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination data={props?.rows || []} state={(items: Array<any>) => setTableProductos(items)} items={10}/>
    </div>
  )
}

export default TableDTE
